import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MailWarning } from "lucide-react";
import { useAuth } from "../lib/AuthContext";

export default function EmailVerificationBanner() {
  const { user, resendVerification } = useAuth();
  const { t } = useTranslation("auth");
  // idle | sending | sent | error
  const [state, setState] = useState("idle");

  if (!user) return null;
  if (user.email_verification_status === "ok") return null;

  const onResend = async () => {
    setState("sending");
    try {
      await resendVerification();
      setState("sent");
    } catch {
      setState("error");
    }
  };

  return (
    <div
      className="flex flex-wrap items-center gap-3 px-4 py-3 bg-amber-50 border-b border-amber-200 text-amber-900"
      data-testid="email-verification-banner"
      role="alert"
    >
      <MailWarning size={18} strokeWidth={1.75} className="shrink-0 text-amber-700" />
      <div className="min-w-0 text-sm">
        <span className="font-medium">{t("email_verification.banner_title")}</span>{" "}
        <span className="text-amber-800">{t("email_verification.banner_body")}</span>
      </div>
      <div className="ml-auto shrink-0 flex items-center gap-3">
        {state === "sent" && (
          <span className="text-xs text-amber-800" data-testid="email-verification-banner-sent" aria-live="polite">
            {t("email_verification.banner_sent")}
          </span>
        )}
        {state === "error" && (
          <span className="text-xs text-rose-700" data-testid="email-verification-banner-error" aria-live="polite">
            {t("email_verification.banner_error")}
          </span>
        )}
        <button
          onClick={onResend}
          disabled={state === "sending" || state === "sent"}
          data-testid="email-verification-banner-cta"
          className="h-8 px-3 rounded-lg bg-amber-600 hover:bg-amber-700 disabled:opacity-50 disabled:cursor-not-allowed text-white text-xs font-medium transition-colors"
        >
          {t("email_verification.banner_cta")}
        </button>
      </div>
    </div>
  );
}
